import r from './responsive';
import d from './dimensions';
import dv from './device';
export const responsive = r;
export const dimensions = d;
export const device = dv;
export default {
    responsive: r,
    dimensions: d,
    device: dv,
};
//# sourceMappingURL=index.js.map